import React from 'react'
import Icon from 'meinian-package/src/component/icon'
import classNames from 'classnames'
import Carousel from './carousel'
import styles from './index.module.less'

export default ({ onClose, options }) => {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>
    {
    !!options.length && <div className={styles['mn-workbench-banner']}>
      <div
        className={classNames(styles['mn-workbench-banner-close'])}
        onClick={() => {
          onClose?.(options.map(item => item.id)?.join(','))
        }}
      >
        <Icon type="m-guanbi" />
      </div>
      {
        options.length > 1 ? <Carousel>
          {
            options.map(item => <img
              className={styles['mn-workbench-banner-image']}
              src={item.srcUrl}
              onClick={() => {
                window.open(item.jumpUrl)
              }}
            />)
          }
        </Carousel> : <>
          {
            options.map(item => <img
              className={styles['mn-workbench-banner-image']}
              src={item.srcUrl}
              onClick={() => {
                window.open(item.jumpUrl)
              }}
            />)
          }
        </>
      }
    </div>
  }
  </>
}
